<template>
    <div id="Scheduled_Visits" class="dashboard-card d-flex">
        <CardTemplate>
            <!-- HEADER -->
            <template #header>
                <section class="card-title">
                    <span>Scheduled Visits (Past 30 Days)</span>
                </section>
            </template>
            <!-- CONTENT -->
            <!-- LOADING -->
            <template #content>
                <div class="mt-3 text-center" v-if="isLoading && !hasError">
                    <i class="fas fa-spinner fa-pulse fa-fw"></i>
                    <b>Loading your scheduling visit count</b>
                    <i class="fas fa-spinner fa-pulse fa-fw"></i>
                </div>
                <!-- ERROR -->
                <div class="mt-5 text-center" v-if="hasError && !isLoading">
                    <p>
                        There was a problem while fetching your scheduling visit count.
                        <br />
                        Please try again.
                    </p>
                    <button class="btn btn-primary" @click="getVisitCount()">Try Again</button>
                </div>
                <!-- NO DATA -->
                <section v-if="visitCounts.length === 0 && !isLoading && !hasError" class="no-data">
                    <i class="mb-3"> Good Job! There were no scheduling visit count. </i>
                </section>
                <!-- DATA -->
                <div class="h-100 overflow-auto position-relative" v-if="visitCounts.length > 0">
                    <table id="dashboard-table">
                        <tr>
                            <th>Service</th>
                            <th>Missed</th>
                            <th>Unassigned</th>
                            <th>Not Yet Started</th>
                        </tr>
                        <tr v-for="visit in visitCounts" :key="visit.id">
                            <td>{{ ApplicationNamesEnum.getDescriptionUsingValue(visit.Application) }}</td>
                            <td>{{ visit.Counts.MissedVisitCount }}</td>
                            <td>{{ visit.Counts.UnassignedVisitCount }}</td>
                            <td>{{ visit.Counts.NotYetStartedVisitCount }}</td>
                        </tr>
                    </table>
                    <div class="w-100 last-div table-background position-absolute">
                        Unassigned home health visits are visits that have not yet been scheduled per the ordered visit frequency.
                    </div>
                </div>
            </template>
        </CardTemplate>
    </div>
</template>

<script lang="ts" src="./Scheduled.ts"></script>
